import Box from '@mui/material/Box';
import { useCallback, useEffect, useState } from 'react';
import { useGeUnstockService } from 'subModule/src/services/inventory/useInventory';
import { useSnackbar } from 'notistack';
import AlertMessages from 'common/Alert/AlertMessages';
import { useTranslation } from 'react-i18next';
import { checkPrivileges } from 'Helpers/CheckPrivileges';
import Loader from 'layout/Loader';
import BackendPaginationTable from 'common/Table/TableWithPagination';
import ComponentHeaderTwo from 'common/ComponentHeaderTwo/ComponentHeaderTwo';
import StockIcon from '@mui/icons-material/Inventory';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import StyledInput from 'common/SearchField/Search';

export default function UnstockListing() {
    const navigate = useNavigate();
    const [pageNo, setPageNo] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [searchTerm, setSearchTerm] = useState<any>('');
    const [search, setSearch] = useState('');
    const { data: tableData, isFetching, refetch } = searchTerm ? useGeUnstockService({ pageNumber: pageNo, size: pageSize, unStockNumber: searchTerm }) : useGeUnstockService({ pageNumber: pageNo, size: pageSize });
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const fetchData = useCallback(() => {
        refetch().then((res: any) => {
            if (!res?.data?.pages[0]?.success) enqueueSnackbar(<AlertMessages text={res?.data?.pages[0]?.message || "Something went wrong"} />, { variant: "error" });
        });
    }, []);
    useEffect(() => {
        fetchData();
    }, [pageNo, pageSize, searchTerm]);
    const handleChangePage = (pageNo: number) => {
        setPageNo(pageNo + 1);
    }
    const handleChangeRows = (pageSize: number) => {
        setPageSize(pageSize);
        setPageNo(1);
    }
    const showRowView = (row: any) => navigate('/inventory/unstock/' + row.id + '/print');
    const clearSearch = () => {
        setSearch('');
        setSearchTerm('');
        if(searchTerm) { handleSearch(''); }
    }
    const handleSearch = (search: string) => {
        setSearchTerm(search);
        setPageNo(1);
        setPageSize(pageSize);
    };
    
    const handleSearchClick = () => {
        const trimmedSearch = search.trim();
        if (trimmedSearch !== '') {
          handleSearch(trimmedSearch);
        }
    };
    
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value.trim());
        if (!event.target.value.trim()) handleSearch('');
    };

    return (
        <Box>
            <ComponentHeaderTwo
                showBtn={true}
                showSaveBtn={false}
                onClick={() => navigate('/inventory/new-unstock/')}
                heading={t('Unstock')}
                icon={<StockIcon sx={{ fill: '#000', width: '30px', height: '30px', marginTop: '3px' }} />}
                btnText={"create"}
                btnType={"create"}
                showCreateBtn={checkPrivileges("ROLE_UNSTOCK_CREATE")}
            />
            <Box>
                {isFetching ? <Loader /> :
                    <div id="mainListingTable">
                        <BackendPaginationTable
                            columns={[
                                { id: 'unStockNumber', label: 'Unstock Number', numeric: false },
                                { id: 'storeTitle', label: 'Store', numeric: false },
                                { id: 'totalQuantity', label: 'totalQuantity', numeric: false },
                            ]}
                            data={tableData?.pages[0]?.data?.content || []}
                            pageNo={pageNo}
                            pageSize={pageSize}
                            tableData={tableData?.pages[0]?.data || {}}
                            showCheckbox={false}
                            showActions={true}
                            enableSorting={true}
                            showHeader={true}
                            showSearch={true}
                            showFilter={true}
                            showCreateButton={true}
                            actions={[]}
                            handleChangePage={handleChangePage}
                            handleChangeRows={handleChangeRows}
                            rowClick={checkPrivileges("ROLE_UNSTOCK_AUTHORIZE")}
                            showRowView={showRowView}
                            loadingSearch={false}
                            headerComponent={<Grid container spacing={2}>  
                            <Grid item xs={12} md={7} lg={5}>
                            <StyledInput
                                fullWidth
                                placeholder={t("Unstock Number")}
                                handleSearchClick={handleSearchClick}
                                handleChange={handleInputChange}
                                value={search}
                                clearSearch={clearSearch}
                            />
                            </Grid>
                        </Grid>}
                        />
                    </div>
                }
            </Box>
        </Box>
    )
}